import { Notification } from '../../../redux/Notification/NotificationType';
import ButtonComponent from '../../Button.component';
import InfiniteScroll from 'react-infinite-scroll-component';
import SpinnerComponent from '../../Spinner.component';
import NotificationBlockComponent from '../../Blocks/NotificationBlock.component';
import { uniqueId } from 'lodash';
import { checkUserRequiredRole } from '../../../utils/getUserRolesByToken';
import { UserRole } from '../../../types/userRole.types';
import React, { useEffect } from 'react';
import styled, { useTheme } from 'styled-components';
import { useAppDispatch } from '../../../hooks/useAppDispatcher.hook';
import { useAppSelector } from '../../../hooks/useAppSelector.hook';
import {
  getNotificationsList,
  resetNotificationCounter,
  resetNotificationList,
} from '../../../redux/Notification/NotificationSlice';
import { useTranslation } from 'react-i18next';
import useAuthHook from '../../../hooks/useAuth.hook';
import {
  getNotificationsListThunk,
  markAllAsReadNotificationThunk,
  removeAllReadNotificationThunk,
} from '../../../redux/Notification/NotificationThunk';
import { getCandidateRecordListThunk } from '../../../redux/Candidate/Record/Record.thunk';
import ApiWrapper from '../../../hooks/useApi.hook';
import { NotificationsModalEmptyListComponent } from './NotificationsModalEmptyList.component';
import { Transition } from 'react-transition-group';
import { BaseModalProps } from '../BaseModal.component';

const StyledNotificationsContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 100%;
`;

const StyledScrollableNotificationsList = styled.div`
  flex-grow: 1;
  overflow: auto;
`;

interface Props extends BaseModalProps {
  targetType?: string;
  targetId?: number | string;
  personId?: number | string;
  isAccessDelete?: boolean;
  isAccessReadAll?: boolean;
}

const NOTIFICATIONS_PER_PAGE = 12;

export const NotificationsModalListComponent = (
  restProps: Props,
) => {
  const theme = useTheme() as any;

  const dispatch = useAppDispatch();
  const {
    items: notifications,
    loading: isNotificationsLoading,
    pagination,
  } = useAppSelector(getNotificationsList);
  const { t } = useTranslation();
  const { user } = useAuthHook();

  useEffect(() => {
    dispatch(
      getNotificationsListThunk({
        ...restProps,
        page: 1,
        perPage: NOTIFICATIONS_PER_PAGE,
      }),
    );

    return () => {
      dispatch(resetNotificationList()); // ? зачем??
      // TODO: выяснить: зачем getCandidateRecordListThunk?
      // ! то же самое делается тут openModal(NewNotificationModalComponent, {
      restProps.personId &&
        dispatch(getCandidateRecordListThunk({ personId: restProps.personId }));
    };
  }, [dispatch]);

  const handleMarkAllAsReadClick = async () => {
    const result = await dispatch(markAllAsReadNotificationThunk());
    if (result) {
      dispatch(getNotificationsListThunk({ ...restProps, page: 1 }));
      dispatch(resetNotificationCounter());
    }
  };

  const handleDeleteAllNotificationsClick = () => {
    ApiWrapper(removeAllReadNotificationThunk()).then((res: boolean) => {
      res && dispatch(getNotificationsListThunk({ ...restProps, page: 1 }));
    });
  };

  const loadMoreNotifications = () => {
    dispatch(
      getNotificationsListThunk({
        page: pagination.currentPage + 1,
        perPage: NOTIFICATIONS_PER_PAGE,
      }),
    );
  };

  const hasMoreNotificationsToLoad =
    pagination.currentPage < pagination.lastPage;

  if (!notifications && notifications.length < 0)
    return <NotificationsModalEmptyListComponent />;

  return (
    <StyledNotificationsContentWrapper>
      {restProps.isAccessReadAll &&
        notifications.find(
          (notification: Notification) => !notification.readAt,
        ) && (
          <ButtonComponent
            handleClick={() => handleMarkAllAsReadClick()}
            style={{ margin: '10px 0' }}
          >
            {t('markAllAsRead')}
          </ButtonComponent>
        )}

      <ButtonComponent
        handleClick={handleDeleteAllNotificationsClick}
        style={{ margin: '10px 0' }}
      >
        {t('deleteAllReadNotifications')}
      </ButtonComponent>

      <StyledScrollableNotificationsList id="scrollableNotificationsList">
        <InfiniteScroll
          dataLength={notifications.length}
          next={loadMoreNotifications}
          hasMore={hasMoreNotificationsToLoad}
          loader={<SpinnerComponent />}
          scrollableTarget="scrollableNotificationsList"
        >
          {notifications.map((notification: Notification) => (
            <NotificationBlockComponent
              key={uniqueId('notification-')}
              isCommon={!restProps.targetId}
              {...notification}
              isAccessDelete={
                restProps.isAccessDelete &&
                (checkUserRequiredRole(user.roles, [
                  UserRole.SUPER_HR,
                  UserRole.ADMIN,
                  UserRole.DEV_ADMIN,
                  UserRole.DEV_SUPER_HR,
                ]) ||
                  notification.user?.id === user.id)
              }
            />
          ))}
        </InfiniteScroll>
        <Transition
          in={isNotificationsLoading}
          mountOnEnter
          unmountOnExit
          timeout={{ exit: 300 }}
        >
          {state => (
            <SpinnerComponent
              style={{
                ...theme.animations.reverseDefaultState,
                ...theme.animations.defaultSteps[state],
              }}
            />
          )}
        </Transition>
      </StyledScrollableNotificationsList>
    </StyledNotificationsContentWrapper>
  );
};
